import { render, staticRenderFns } from "./PollView.vue?vue&type=template&id=33c00aaf&scoped=true&"
import script from "./PollView.vue?vue&type=script&lang=ts&"
export * from "./PollView.vue?vue&type=script&lang=ts&"
import style0 from "./PollView.vue?vue&type=style&index=0&id=33c00aaf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c00aaf",
  null
  
)

export default component.exports